<script>
  import SubmissionWizard from './Wizard'
  import ValidationMessage from '../../../../components/form/ValidationMessage.vue'
  import DataService from '../../../../services/dataService'
  import * as restfulService from '../../../../services/restfulService'
  import {mapGetters} from 'vuex'
  import bus from '@utils/bus'
  import {required, email, url} from 'vuelidate/lib/validators'

  export default {
    components: {SubmissionWizard, ValidationMessage},
    props: ['submission'],
    data () {
      return {
        isSubmitted: false,
        isSearchingAuthor: false,
        data: {
          activeStep: 'authors',
          fields: [],
          event_paper_type: {},
          authors: []
        },
        dependencies: {
          countries: [],
          authors: []
        }
      }
    },
    computed: {
      ...mapGetters(['currentUser']),
      authors: function () {
        return this.data.authors.filter(item => item.type === 'autor')
      },
      advisors: function () {
        return this.data.authors.filter(item => item.type === 'orientador')
      },
      coAdvisors: function () {
        return this.data.authors.filter(item => item.type === 'co_orientador')
      },
      canAddAuthor: function () {
        return this.data.event_paper_type.author_limit > this.data.authors.length
      },
      canAddAdvisor: function () {
        return this.canAddAuthor && this.advisors.length < this.data.event_paper_type.max_limit_advisor
      },
      canAddCoAdvisor: function () {
        return this.canAddAuthor && this.data.event_paper_type.co_advisor && (this.data.event_paper_type.max_limit_co_advisor === 0 || this.coAdvisors.length < this.data.event_paper_type.max_limit_co_advisor)
      },
      hasAdvisor: function () {
        return this.advisors.length > 0
      },
      hasCoAdvisor: function () {
        return this.coAdvisors.length > 0
      },
      needAdvisor: function () {
        return this.data.event_paper_type.advisor
      },
      needCoAdvisor: function () {
        return this.data.event_paper_type.co_advisor && this.data.event_paper_type.max_limit_co_advisor > 0
      },
      needAuthorSubscribed () {
        return this.data.event_paper_type.author_subscribed
      }
    },
    mounted () {
      if (!this.submission) {
        this.$router.push({name: 'submission.home'})
      }
      this.getDependencies()
      this.data = {...this.data, ...this.submission}
      this.data.activeStep = 'authors'
      if (this.data.authors.length === 0) {
        this.getAuthAuthorInformation()
      }
      bus.$emit('hide-loader')
    },
    validations: {
      data: {
        authors: {
          required,
          $each: {
            first_name: {required},
            last_name: {required},
            email: {required, email},
            orcid: {url},
            country_id: {required},
            biography: {required}
          }
        }
      }
    },
    methods: {
      getDependencies () {
        DataService.get([
          {domain: 'country'}
        ]).then((result) => {
          this.dependencies = {...this.dependencies, ...result}
        })
      },
      onSearchAuthor (query) {
        this.dependencies.authors.splice(0)
        if (query !== '') {
          this.isSearchingAuthor = true
          let data = {ref_pessoa: {ilike: '%' + query + '%'}}
          restfulService.search('person', null, data, null, null, 1, 20)
            .then((response) => {
              this.dependencies.authors = [...this.dependencies.authors, ...response.data]
              this.isSearchingAuthor = false
            })
            .catch(e => {
              console.log(e)
            })
        }
      },
      onSelectAuthor (index, personId) {
        if (personId) {
          const person = this.dependencies.authors.filter(item => item.id === personId)[0]
          const author = this.data.authors[index]
          let name = person.pessoa.nome.split(' ')
          author.person_id = person.id
          author.author_subscribed = true
          author.first_name = name[0]
          author.first_name_disabled = true
          author.last_name = name[name.length - 1]
          author.last_name_disabled = true
          author.email = person.pessoa.email
          author.email_disabled = true
          author.country_id = person.pessoa.ref_nacionalidade
          author.country_id_disabled = true
          if (!person.pessoa.email || person.pessoa.email === '') {
            author.email_disabled = false
          }
          if (!person.pessoa.country_id || person.pessoa.country_id === '') {
            author.country_id_disabled = false
          }
          this.data.authors.splice(index, 1, author)
        }
      },
      getAuthAuthorInformation () {
        restfulService.get('person', 'author-info')
          .then((response) => {
            const author = {
              type: 'autor',
              person_id: this.currentUser.id,
              primary_contact: true,
              author_subscribed: true,
              first_name: response.first_name,
              first_name_disabled: true,
              last_name: response.last_name,
              last_name_disabled: true,
              email: response.email,
              email_disabled: true,
              seq: 1,
              country_id: response.country_id,
              country_id_disabled: true
            }
            if (!response.email || response.email === '') {
              author.email_disabled = false
            }
            if (!response.country_id || response.country_id === '') {
              author.country_id_disabled = false
            }
            this.data.authors.push(author)
          })
          .catch(e => {
            console.log(e)
          })
      },
      addAuthor () {
        this.data.authors.push({
          type: 'autor',
          primary_contact: this.data.authors.length === 0,
          author_subscribed: false,
          first_name: '',
          first_name_disabled: false,
          last_name: '',
          last_name_disabled: false,
          email: '',
          email_disabled: false,
          seq: this.authors.length + 1,
          orcid: '',
          country_id: '',
          country_id_disabled: false,
          biography: ''
        })
      },
      addAdvisor () {
        this.data.authors.push({
          type: 'orientador',
          primary_contact: false,
          author_subscribed: false,
          first_name: '',
          first_name_disabled: false,
          last_name: '',
          last_name_disabled: false,
          email: '',
          email_disabled: false,
          seq: this.advisors.length + 1,
          orcid: '',
          country_id: '',
          country_id_disabled: false,
          biography: ''
        })
      },
      addCoAdvisor () {
        this.data.authors.push({
          type: 'co_orientador',
          primary_contact: false,
          author_subscribed: false,
          first_name: '',
          first_name_disabled: false,
          last_name: '',
          last_name_disabled: false,
          email: '',
          email_disabled: false,
          seq: this.coAdvisors.length + 1,
          orcid: '',
          country_id: '',
          country_id_disabled: false,
          biography: ''
        })
      },
      delAuthor (index) {
        if (index > 0) {
          this.data.authors = this.data.authors.filter((item, i) => {
            return i !== index
          })
        }
      },
      onPrimaryContact (index) {
        this.data.authors.forEach((item) => {
          item.primary_contact = false
        })
        this.data.authors[index].primary_contact = true
      },
      authorSubscribed (index) {
        const author = this.data.authors[index]
        if (!author.author_subscribed) {
          author.first_name_disabled = false
          author.last_name_disabled = false
          author.email_disabled = false
          author.country_id_disabled = false
        } else {
          author.person_id = ''
          author.first_name = ''
          author.last_name = ''
          author.email = ''
          author.orcid = ''
          author.country_id = ''
          author.biography = ''
        }
        this.data.authors.splice(index, 1, author)
      },
      onNextStep (nextRoute) {
        let params = {submission: this.data}
        this.$router.push({name: nextRoute, params})
      }
    }
  }
</script>

<template>
    <div>
        <submission-wizard :active-step="data.activeStep"
                           :main-event="data.main_event"
                           :event="data.event"
                           :paper-type="data.paper_type"/>
        <div class="forms form-registration">
            <div class="buttons-center">
                <el-button type="default"
                           size="large"
                           @click="onNextStep('submission.contents')">
                    <i class="fa fa-arrow-left"></i>
                    <span>Voltar</span>
                </el-button>
            </div>
            <el-alert title="Dicas da Submissão"
                      class="submission-tips"
                      type="warning"
                      :closable="false">
                <ul>
                    <li>Lembre-se de preencher todos os campos com * (asterisco), eles são obrigatórios.</li>
                    <li>Verifique o email dos autores, orientadores e coorientadores para que eles recebam as
                        notificações corretamente.
                    </li>
                </ul>
            </el-alert>
            <div class="btn-authors">
                <el-button type="success"
                           v-if="canAddAuthor"
                           @click="addAuthor">
                    <i class="fa fa-plus"></i>
                    <span>Incluir Autor</span>
                </el-button>
                <el-button type="warning"
                           v-if="canAddAdvisor"
                           @click="addAdvisor">
                    <i class="fa fa-plus"></i>
                    <span>Incluir Orientador</span>
                </el-button>
                <el-button type="info"
                           v-if="canAddCoAdvisor"
                           @click="addCoAdvisor">
                    <i class="fa fa-plus"></i>
                    <span>Incluir Co-Orientador</span>
                </el-button>
            </div>
            <el-form ref="submission"
                     :model="data"
                     label-position="top">
                <h3 class="title-separator">Autores</h3>
                <div class="author-item"
                     v-for="(author, index) in data.authors"
                     v-bind:class="{'-advisor': (author.type === 'orientador' || author.type === 'co_orientador')}">
                    <el-button type="danger"
                               size="small"
                               v-if="index > 0"
                               class="del-author"
                               @click="delAuthor(index)">
                        <i class="fa fa-times"></i>
                    </el-button>
                    <h3>
                        {{(author.type === 'orientador' ? 'Orientador ' : (author.type === 'co_orientador' ?
                        'Co-Orientador ' : 'Autor ') ) + author.seq}}
                        <el-checkbox v-model="author.primary_contact"
                                     v-if="author.type === 'autor'"
                                     label="Contato Principal"
                                     @change="onPrimaryContact(index)">
                        </el-checkbox>
                        <el-checkbox v-model="author.author_subscribed"
                                     v-if="needAuthorSubscribed && index > 0 && author.type === 'autor'"
                                     label="Inscrito no Evento"
                                     @change="authorSubscribed(index)">
                        </el-checkbox>
                    </h3>
                    <el-form-item label="Buscar autor"
                                  v-if="author.author_subscribed && index > 0">
                        <el-select v-model="author.person_id"
                                   filterable
                                   clearable
                                   remote
                                   :remote-method="onSearchAuthor"
                                   :loading="isSearchingAuthor"
                                   @change="onSelectAuthor(index, author.person_id)"
                                   placeholder="Digite a matrícula do autor"
                                   empty-text="Nenhum registro encontrado"
                                   class="el-select-full">
                            <el-option v-for="item in dependencies.authors"
                                       v-if="item.id !== currentUser.id"
                                       :key="item.id"
                                       :label="item.ref_pessoa + ' - ' + item.pessoa.nome"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="Primeiro Nome"
                                          class="is-required">
                                <el-input v-model="author.first_name"
                                          :disabled="author.first_name_disabled"
                                          :maxlength="200"
                                          @input="$v.data.authors.$each[index].first_name.$touch()"/>
                                <validation-message
                                        v-if="!$v.data.authors.$each[index].first_name.required && $v.data.authors.$each[index].first_name.$dirty"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Sobrenome"
                                          class="is-required">
                                <el-input v-model="author.last_name"
                                          :disabled="author.last_name_disabled"
                                          :maxlength="200"
                                          @input="$v.data.authors.$each[index].last_name.$touch()"></el-input>
                                <validation-message
                                        v-if="!$v.data.authors.$each[index].last_name.required && $v.data.authors.$each[index].last_name.$dirty"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="E-mail"
                                          class="is-required">
                                <el-input v-model="author.email"
                                          :disabled="author.email_disabled"
                                          :maxlength="200"
                                          @input="$v.data.authors.$each[index].email.$touch()"/>
                                <validation-message
                                        v-if="!$v.data.authors.$each[index].email.required && $v.data.authors.$each[index].email.$dirty"/>
                                <validation-message
                                        v-if="!$v.data.authors.$each[index].email.email && $v.data.authors.$each[index].email.$dirty"
                                        message="O e-mail precisa ser válido."/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item>
                                <span slot="label" class="popover__wrapper">
                                    ORCID iD <el-icon class="el-icon-information"/>
                                    <div class="popover__content">
                                        <p class="popover__message">O identificador ORCID pode ser obtido no registro ORCID. Você deve aceitar os padrões para apresentação de iD ORCID e incluir a URL completa (por exemplo: http://orcid.org/0000-0002-1825-0097).</p>
                                    </div>
                                </span>
                                <el-input v-model="author.orcid"
                                          :maxlength="200"
                                          @input="$v.data.authors.$each[index].orcid.$touch()"/>
                                <validation-message
                                        v-if="!$v.data.authors.$each[index].orcid.url && $v.data.authors.$each[index].orcid.$dirty"
                                        message="A URL precisa ser válida."/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="País"
                                          class="is-required">
                                <el-select v-model="author.country_id"
                                           filterable
                                           clearable
                                           placeholder="Selecione uma Nacionalidade"
                                           empty-text="Nenhum registro encontrado"
                                           :disabled="author.country_id_disabled"
                                           class="el-select-full"
                                           @input="$v.data.authors.$each[index].country_id.$touch()">
                                    <el-option
                                            v-for="item in dependencies.countries"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                                <validation-message
                                        v-if="!$v.data.authors.$each[index].country_id.required && $v.data.authors.$each[index].country_id.$dirty"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="Qualificação/Titulação"
                                  class="is-required">
                        <span slot="label" class="popover__wrapper">
                            Qualificação/Titulação <el-icon class="el-icon-information"/>
                            <div class="popover__content">
                                <p class="popover__message">Este campo deve ser preencido com a Titulação, por exemplo: Doutor em computação aplicada a mineração de dados</p>
                            </div>
                        </span>
                        <el-input v-model="author.biography"
                                  type="textarea"
                                  :rows="3"
                                  :maxlength="500"
                                  @input="$v.data.authors.$each[index].biography.$touch()"/>
                        <validation-message
                                v-if="!$v.data.authors.$each[index].biography.required && $v.data.authors.$each[index].biography.$dirty"/>
                    </el-form-item>
                </div>
                <el-form-item class="buttons-save">
                    <el-button type="default"
                               size="large"
                               @click="onNextStep('submission.contents')">
                        <i class="fa fa-arrow-left"></i>
                        <span>Voltar</span>
                    </el-button>
                    <el-button type="primary"
                               size="large"
                               @click="onNextStep('submission.confirmation')"
                               :disabled="isSubmitted || $v.data.$invalid || (needAdvisor && !hasAdvisor) || (needCoAdvisor && !hasCoAdvisor)">
                        <i class="fa fa-arrow-right"></i>
                        <span>Salvar e Avançar</span>
                    </el-button>
                    <span class="helper-text"
                          v-if="!$v.data.authors.$dirty && (needAdvisor && !hasAdvisor)">É obrigatório incluir um orientador na submissão dos trabalhos.</span>
                    <span class="helper-text"
                          v-if="!$v.data.authors.$dirty && (needCoAdvisor && !hasCoAdvisor)">É obrigatório incluir um co-orientador na submissão dos trabalhos.</span>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<style lang="scss">
    .btn-authors {
        padding-bottom: 20px;
    }

    .author-item {
        background-color: #f4f4f4;
        padding: 10px;
        border-radius: 4px;
        margin-bottom: 20px;
        position: relative;

        &.-advisor {
            background-color: rgba(255, 189, 8, 0.17);
        }

        .del-author {
            position: absolute;
            right: 5px;
            top: 5px;
        }
    }

    .popover__wrapper {
        position: relative;
        display: inline-block;
    }

    .popover__content {
        width: 300px;
        opacity: 0;
        visibility: hidden;
        position: absolute;
        transform: translate(0, 10px);
        background-color: #FFF;
        border-radius: 6px;
        padding: 15px;
        box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.15);
        left: -150px;
    }

    .popover__wrapper:hover .popover__content {
        z-index: 10;
        opacity: 1;
        visibility: visible;
    }

    .popover__message {
        text-align: center;
    }

    .helper-text {
        color: #ff4949;
        font-size: 12px;
        line-height: 1;
        padding-left: 10px;
    }
</style>
